var MyDocumentsEdit = (function ($) {

    MyDocumentsEdit = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options['$wrapper'];

        that.$form = that.$wrapper.find('form');
        that.$submit_button = that.$form.find('.js-button');
        that.$delete_button = that.$wrapper.find('.js-button-delete');

        // INPUTS
        that.$inputs = that.$wrapper.find('.js-input');
        that.$inputs_full_name = that.$wrapper.find('.js-name');
        that.$consistent_name = that.$wrapper.find('.js-consistent-name');
        that.$input_citizenship = that.$wrapper.find('.js-citizenship');
        that.$input_doc_code = that.$wrapper.find('.js-doc-code');
        that.$input_doc_number = that.$wrapper.find('.js-doc-number');
        that.$doc_expire_wrapper = that.$wrapper.find('.js-doc-expire-wrapper');
        that.$input_doc_date_expire = that.$doc_expire_wrapper.find('.js-doc-date-expire');
        that.$doc_select = that.$wrapper.find('.js-doc-select');
        that.$inputs_select = that.$wrapper.find('.js-input-select');
        that.$select_input_fields = that.$inputs_select.find('.select-input input');
        that.$input_birthday = that.$wrapper.find('.js-input-birthday');
        that.$document_id_input = that.$wrapper.find('.js-document-id');

        // OPTIONS
        that.document_id = options['document_id'];
        that.modals = options['modals'];
        that.locales = options['locales'] || {};
        that.is_edit = options['is_edit'];

        // CONST
        that.class = {
            hidden: 'hidden',
            error: 'error'
        };

        that.duplicate_code = 50034;
        that.save_doc_url = 'my/documents/save/';
        that.delete_doc_url = 'my/documents/delete/';
        that.operation = {
            save: 'save',
            delete: 'delete',
        };

        // DYNAMIC
        that.is_locked = false;
        that.filled_after_init = false;

        that.init();
    };

    MyDocumentsEdit.prototype.init = function () {
        var that = this;

        that.__initFields();

        that.__initFieldHandlers()

        that.__setupDocSelectByCitizenship(that.$input_citizenship.val());

        that.__initSubmit();

        that.__initDelete();
        
        that.filled_after_init = true;
       
    };
    
    MyDocumentsEdit.prototype.__checkEditMode = function ($input) {
        var that = this;
        
        if (that.is_edit && that.filled_after_init) {
            $input.val('');
        }
    }

    MyDocumentsEdit.prototype.__initFields = function () {
        var that = this,
            $input_checkbox_switch = that.$wrapper.find('.js-checkbox-switch');

        that.__setupDateMask(that.$input_birthday, 'birthday');

        that.__setupNameInputsMask();

        that.__setupDocNumberMask();

        that.__initDocCodeField();

        that.__disableTextByCheckbox($input_checkbox_switch);
    };

    MyDocumentsEdit.prototype.__initFieldHandlers = function () {
        var that = this;

        that.$inputs.on('input', function () {
            that.__initInputInput($(this));
        });

        that.$inputs.on('blur', function () {
            that.__initInputBlur($(this));
        });

        that.$select_input_fields.on('blur', function () {
            that.__initInputBlur($(this));
        });
    };

    MyDocumentsEdit.prototype.__setupDocNumberMask = function () {
        var that = this,
            doc_code = that.$input_doc_code.val(),
            $input_error_text = that.$input_doc_number.data('error-text'),

            $input_wrapper = that.$input_doc_number.parents('.input'),
            $input_description = $input_wrapper.find('.description'),
            $input_icon = $input_wrapper.find('.js-icon-visible'),
            $input_icon_sr = $input_wrapper.find('.js-icon-SR'),
            $input_icon_np = $input_wrapper.find('.js-icon-NP'),
            $input_icon_za = $input_wrapper.find('.js-icon-ZA'),
            complete = false;

        that.__checkEditMode(that.$input_doc_number);
        UIInput.prototype.clearError(that.$input_doc_number);

        switch (doc_code) {
            case 'PS':
                that.$input_doc_number.inputmask({
                    mask: '9999 999999',
                    placeholder: '_',
                    autoUnmask: true,
                    onKeyValidation: function (key, result) {
                        if (!result && complete === false) {
                            UIInput.prototype.setError(that.$input_doc_number, $input_error_text, true);
                        } else {
                            UIInput.prototype.clearError(that.$input_doc_number);
                        }
                    },
                    onKeyDown: function (key) {
                        UIInput.prototype.clearError(that.$input_doc_number);
                        if (key.code === 'Backspace') {
                            complete = false;
                        }
                    },
                    oncomplete: function () {
                        complete = true;
                    },
                    onincomplete: function () {
                        complete = false;
                    },
                    oncleared: function () {
                        complete = false;
                    }
                });

                $input_description.text(that.$input_doc_number.data('description-ps'));
                $input_icon.prop('hidden', true);
                break;

            case 'SR':
                that.$input_doc_number.inputmask({
                    mask: 'x{1,5}-cc 999999',
                    placeholder: '_',
                    casing: 'upper',
                    autoUnmask: true,
                    definitions: {
                        'x': {
                            validator: '[\u0049\u0069\u0056\u0076\u0058\u0078]'
                        },
                        'c': {
                            validator: '[\u0410-\u044F]'
                        }
                    },
                    onKeyValidation: function (key, result) {
                        if (!result && complete === false) {
                            UIInput.prototype.setError(that.$input_doc_number, $input_error_text, true);
                        } else {
                            UIInput.prototype.clearError(that.$input_doc_number);
                        }
                    },
                    onKeyDown: function (key) {
                        UIInput.prototype.clearError(that.$input_doc_number);
                        if (key.code === 'Backspace') {
                            complete = false;
                        }
                    },
                    oncomplete: function () {
                        complete = true;
                    },
                    onincomplete: function () {
                        complete = false;
                    },
                    oncleared: function () {
                        complete = false;
                    }
                });

                $input_description.text(that.$input_doc_number.data('description-sr'));
                $input_icon.prop('hidden', true);
                $input_icon_sr.prop('hidden', false);
                break;

            case 'PSP':
                $input_description.text(that.$input_doc_number.data('description-psp'));
                $input_icon.prop('hidden', true);

                that.$input_doc_number.inputmask({
                    mask: '99 9999999',
                    placeholder: '_',
                    autoUnmask: true,
                    onKeyValidation: function (key, result) {
                        if (!result && complete === false) {
                            UIInput.prototype.setError(that.$input_doc_number, $input_error_text, true);
                        } else {
                            UIInput.prototype.clearError(that.$input_doc_number);
                        }
                    },
                    onKeyDown: function (key) {
                        UIInput.prototype.clearError(that.$input_doc_number);
                        if (key.code === 'Backspace') {
                            complete = false;
                        }
                    },
                    oncomplete: function () {
                        complete = true;
                    },
                    onincomplete: function () {
                        complete = false;
                    },
                    oncleared: function () {
                        complete = false;
                    }
                });

                break;

            case 'NP':
            case 'ZA':
                $input_icon.prop('hidden', true);

                if (doc_code === 'NP') {
                    $input_description.text(that.$input_doc_number.data('description-np'));
                    $input_icon_np.prop('hidden', false);
                }

                if (doc_code === 'ZA') {
                    $input_description.text(that.$input_doc_number.data('description-za'));
                    $input_icon_za.prop('hidden', false);
                }

                that.$input_doc_number.inputmask({
                    mask: 'xxxxxxxxxxxxxx',
                    jitMasking: true,
                    placeholder: '_',
                    definitions: {
                        'x': {
                            validator: '[0-9-_\u0041-\u005A\u0061-\u007A]'
                        }
                    },
                    onKeyValidation: function (key, result) {
                        if (!result && complete === false) {
                            UIInput.prototype.setError(that.$input_doc_number, $input_error_text, true);
                        } else {
                            UIInput.prototype.clearError(that.$input_doc_number);
                        }
                    },
                    onKeyDown: function (key) {
                        UIInput.prototype.clearError(that.$input_doc_number);
                        if (key.code === 'Backspace') {
                            complete = false;
                        }
                    },
                    oncomplete: function () {
                        complete = true;
                    },
                    onincomplete: function () {
                        complete = false;
                    },
                    oncleared: function () {
                        complete = false;
                    }
                });

                break;

            default:
                that.$input_doc_number.inputmask('remove');
                break;
        }
    };

    MyDocumentsEdit.prototype.__initDocCodeField = function () {
        var that = this;

        that.$input_doc_code.on('input', function () {
            var value = that.$input_doc_code.val();

            switch (value) {
                case 'PS':
                case 'SR':
                    that.__setupNameInputsMask('cyr');
                    that.__setupDocNumberMask();
                    that.__toggleDocumentExpireField(false);
                    UIInput.prototype.clearError(that.$input_doc_date_expire);
                    break;
                case 'PSP':
                case 'NP':
                case 'ZA':
                    that.__setupNameInputsMask('lat');
                    that.__setupDocNumberMask();
                    that.__toggleDocumentExpireField(true);
                    UIInput.prototype.clearError(that.$input_doc_date_expire);
                    break;
            }
        });
    };

    MyDocumentsEdit.prototype.__setupNameInputsMask = function (force_type = null) {
        var that = this;

        that.$inputs_full_name.each(function () {
            var $that = $(this),
                input_type = $that.data('type');

            that.__setupNameInputMask($that, force_type || input_type);
        });
    };

    MyDocumentsEdit.prototype.__setupNameInputMask = function ($input, type) {
        var that = this,
            $input_error_text = $input.data('error-text'),
            $input_warning_text = $input.data('warning-character'),
            complete = false,
            pattern;

        if (type === 'cyr') {
            pattern = 'c'
        }
        if (type === 'lat') {
            pattern = 'l'
        }
        if (type === 'both') {
            pattern = 'b'
        }

        $input.inputmask('remove');
        that.__checkEditMode($input);
        UIInput.prototype.clearError($input);

        $input.inputmask({
            mask: pattern + '{*}',
            definitions: {
                'c': {
                    // cyrillic only, exclude ъЪ 
                    // https://jrgraphix.net/r/Unicode/0400-04FF
                    // last characters: space and minus
                    validator: '[\u0401\u0451\u0410-\u0429\u042B-\u0449\u044B-\u044F -]'
                },
                'l': {
                    // latin only
                    // https://jrgraphix.net/r/Unicode/0020-007F
                    validator: '[\u0041-\u005A\u0061-\u007A]'
                },
                'b': {
                    // both: cyrillic + latin
                    validator: '[\u0041-\u005A\u0061-\u007A\u0401\u0451\u0410-\u0429\u042B-\u0449\u044B-\u044F -]'
                }
            },
            onKeyValidation: function (key, result) {
                if (!result && complete === false) {
                    UIInput.prototype.setError($input, $input_error_text, true);
                    $input.data('set-error-masks', true);
                } else {
                    $input.data('set-error-masks', false);
                }
            },
            onKeyDown: function (key) {
                UIInput.prototype.clearError($input);
                if (key.code === 'Backspace') {
                    complete = false;
                }
                if (key.code === 'Space' || key.code === 'Minus') {
                    UIInput.prototype.setError($input, $input_warning_text, true);
                    $input.data('set-error-masks', true);
                } else {
                    $input.data('set-error-masks', false);
                }
            },
            oncomplete: function () {
                complete = true;
                that.__inputReplace($input);
            },
            onincomplete: function () {
                complete = false;
                that.__inputReplace($input);
            },
            onBeforePaste: function () {
                that.__inputReplace($input);
            },
            oncleared: function () {
                complete = false;
            }
        });
    };

    MyDocumentsEdit.prototype.__toggleDocumentExpireField = function (enabled = false) {
        var that = this;

        if (!that.$doc_expire_wrapper.length || !that.$input_doc_date_expire.length) {
            return false;
        }

        var $input_wrapper = that.$input_doc_date_expire.parents('.input'),
            $input_wrapper_field = $input_wrapper.parents('.field');

        if (enabled) {
            that.$input_doc_date_expire.prop('disabled', false);
            that.$input_doc_date_expire.inputmask('remove')
            that.__checkEditMode(that.$input_doc_date_expire);
            that.__setupDateMask(that.$input_doc_date_expire);
        } else {
            that.$input_doc_date_expire.prop('disabled', true);
            that.$input_doc_date_expire.inputmask('remove').val('');
            $input_wrapper.removeClass('not-empty');
        }
    };

    MyDocumentsEdit.prototype.__setupDateMask = function ($input, validation_field = null) {
        var complete = false,
            $input_error_symbol = $input.data('error-symbol');

        $input.inputmask({
            mask: 'a9.b9.cd99',
            inputmode: 'numeric',
            placeholder: '_',
            definitions: {
                'a': {
                    validator: "[0-3]"
                },
                'b': {
                    validator: "[01]"
                },
                'c': {
                    validator: "[12]"
                },
                'd': {
                    validator: "[09]"
                }
            },
            onKeyValidation: function (key, result) {
                if (!result && complete === false) {
                    UIInput.prototype.setError($input, $input_error_symbol, true);
                } else {
                    UIInput.prototype.clearError($input);
                }
            },
            onKeyDown: function (key) {
                UIInput.prototype.clearError($input);
                if (key.code === 'Backspace') {
                    complete = false;
                }
            },
            oncomplete: function () {
                complete = true;
            },
            onincomplete: function () {
                complete = false;
            },
            oncleared: function () {
                complete = false;
            }
        });
    };

    MyDocumentsEdit.prototype.__disableTextByCheckbox = function ($selector) {
        var that = this;
        
        if (that.is_edit && !that.filled_after_init) {
            changeSwitchTarget($selector);
        }

        $selector.on('change', function () {
            var $that = $(this);
            
            if (this.checked) {
                $that.attr('checked', false);
            } else {
                $that.attr('checked', true);
            }
            changeSwitchTarget($that)
        });

        function changeSwitchTarget($selector) {
            var $wrapper = $selector.parents('.js-checkbox-switch-wrapper'),
                $target = $wrapper.find('.js-checkbox-switch-target');
            
            if ($selector.prop('checked')) {
                $target.attr('disabled', true);
                UIInput.prototype.clearInput($target);
                UIInput.prototype.clearError($target);
            } else {
                $target.removeAttr('disabled').trigger('input');
            }
        }
    };

    MyDocumentsEdit.prototype.__setupDocSelectByCitizenship = function (citizenship) {
        var that = this,
            $doc_list = that.$doc_select.find('.select-options .list'),
            $international = $doc_list.find('.js-international'),
            $non_international = $doc_list.find('.js-non-international'),
            doc_code = (that.is_edit && !that.filled_after_init) ? that.$input_doc_code.val() : null,
            $doc_list_element = doc_code ? $doc_list.find("[data-value='" + doc_code + "']") : null;

        if (citizenship === $.sa.nationality) {
            $non_international
                .show()
                .data('hidden', false);
            $international
                .hide()
                .data('hidden', true);
            
            UISelect.prototype.selectOption(that.$doc_select, $doc_list_element ?? $non_international.first());

        } else {
            $non_international
                .hide()
                .data('hidden', true);
            $international
                .show()
                .data('hidden', false);

            UISelect.prototype.selectOption(that.$doc_select, $doc_list_element ?? $international.first());
        }
    };

    MyDocumentsEdit.prototype.__initInputInput = function ($input) {
        var that = this;

        if ($input.hasClass('js-citizenship')) {
            that.__setupDocSelectByCitizenship(that.$input_citizenship.val());
        }

        if ($input.hasClass('js-name')) {
            that.__validateNameFieldsSumLength();
        }
    };

    MyDocumentsEdit.prototype.__initInputBlur = function ($input) {
        var that = this;

        if ($input.hasClass('js-name')) {
            that.__validateField($input);
        }

        if ($input.hasClass('js-input-select')) {
            that.__validateSelectValue($input);
        }

        if ($input.hasClass('js-doc-number')) {
            that.__validateField($input, that.$input_doc_code.val());
        }

        if ($input.hasClass('js-doc-date-expire')) {
            that.__validateExpireDate(
                that.$input_doc_date_expire
            );
        }
    };

    MyDocumentsEdit.prototype.__validateNameFieldsSumLength = function () {
        var that = this,
            is_valid = true;

        that.$inputs_full_name.each(function () {
            var $input = $(this),
                error_text = $input.data('limit-characters');

            if ($input.val().length > 0) {
                if (!UIInputMask.prototype.validateNameFieldsLength(that.$wrapper)) {
                    UIInput.prototype.setError($input, error_text, true);
                    return false;
                } else if (!$input.data('set-error-masks')) {
                    UIInput.prototype.clearError($input);
                    return true;
                }
            }
        });

        return is_valid;
    };

    MyDocumentsEdit.prototype.__validateField = function ($input, doctype = 'empty') {
        var that = this,
            value = $input.val(),
            error_empty = $input.data('error-empty'),
            error_wrong = $input.data('error-wrong'),
            value_trim = value.replace(/[- _]/g, ''),
            value_length,
            is_valid = true;

        if (!$input.data('set-error')) {
            UIInput.prototype.clearError($input);
        }

        if ($input.prop('disabled')) {
            return true;
        }

        switch (doctype) {
            case 'PS':
                value_length = 10;
                break

            case 'SR':
                // At least one character must be entered in first section
                value_trim = value_trim.replace(/[\u0049\u0069\u0056\u0076\u0058\u0078]{1,5}/g, 'I');
                value_length = 9;
                break

            case 'PSP':
                value_length = 9;
                break

            case 'NP':
            case 'ZA':
            case 'empty':
                value_length = 1;
                value_trim = value.replace('_', '');
        }

        if (value_trim.length < 1) {
            UIInput.prototype.setError($input, error_empty, true);
            is_valid = false;
        } else if (value_trim.length < value_length) {
            UIInput.prototype.setError($input, error_wrong, true);
            is_valid = false;
        }

        return is_valid;
    };

    MyDocumentsEdit.prototype.__inputReplace = function ($input) {
        var cursor_position = $input.prop('selectionStart');

        $input.val($input.val().replace(/[ -]/gm, ''));
        $input.val($input.val().replace(/ё/gm, 'е'));
        $input.val($input.val().replace(/Ё/gm, 'Е'));
        $input.val($input.val().replace(/^[ьЬ]*/gm, ''));

        $input
            .prop('selectionStart', cursor_position)
            .prop('selectionEnd', cursor_position);
    };

    MyDocumentsEdit.prototype.__validateExpireDate = function ($input) {
        var expire = $input.val(),
            expire_trim = expire.replace(/[^0-9]/g, ''),
            expire_formatted = dayjs(expire, 'DD.MM.YYYY', true),
            now_formatted = dayjs.utc($.sa.server_datetime, 'YYYY-MM-DD HH:mm:ss', true),
            error_text = $input.data('error-text'),
            error_expire = $input.data('error-expire'),
            date_diff = 0,

            is_valid = true;

        if ($input.prop('disabled')) {
            return true;
        }

        if (expire_trim.length < 8) {
            UIInput.prototype.setError($input, error_text, true);
            return false;
        }

        if (expire_trim.length === 8) {
            date_diff = expire_formatted.diff(now_formatted, 'day');

            if (date_diff < 0) {
                UIInput.prototype.setError($input, error_expire, true);
                is_valid = false;
            }
        }

        return is_valid;
    };

    MyDocumentsEdit.prototype.__validateAgeAccordingDocument = function ($input) {
        var that = this,
            error_doc_age = $input.data('error-passenger-age'),
            error_text = $input.data('error-text'),
            doc_code = that.$wrapper.find('.js-doc-code').val(),
            birthday = $input.val(),
            birthday_formatted = dayjs(birthday, 'DD.MM.YYYY', true),
            datetime_now = dayjs.utc($.sa.server_datetime, 'YYYY-MM-DD HH:mm:ss', true),
            valid_date_birth = birthday_formatted.isValid(),
            birthdate_14y = birthday_formatted.add(14, 'year'),
            birthdate_14y_90d = birthdate_14y.add(91, 'day'),
            date_diff = 0,
            is_valid = true;

        UIInput.prototype.clearError($input);

        if (!doc_code) {
            return is_valid;
        }

        if (!valid_date_birth) {
            UIInput.prototype.setError($input, error_text, true);
            return false;
        }

        switch (doc_code) {
            case 'PS':
                date_diff = datetime_now.diff(birthday_formatted, 'year', true);
                is_valid = date_diff >= 14;
                break;
            case 'SR':
                date_diff = birthdate_14y_90d.diff(datetime_now, 'day', true);
                is_valid = date_diff >= 0;
                break;
        }

        if (!is_valid) {
            UIInput.prototype.setError($input, error_doc_age, true);
        }

        return is_valid;
    };

    MyDocumentsEdit.prototype.__validateAllFields = function () {
        var that = this,
            $select_buttons = that.$wrapper.find('.js-select-button'),
            is_valid = true;

        if (!that.__validateNameFieldsSumLength()) {
            is_valid = false;
        }

        if (!that.__validateDateValue(that.$input_birthday)) {
            is_valid = false;
        }

        if (!that.__validateField(that.$input_doc_number, that.$input_doc_code.val())) {
            is_valid = false;
        }

        if (!that.__validateAgeAccordingDocument(that.$input_birthday)) {
            is_valid = false;
        }

        if (!that.__validateDateValue(that.$input_doc_date_expire)) {
            is_valid = false;
        }

        if (!that.__validateExpireDate(that.$input_doc_date_expire)) {
            is_valid = false;
        }

        $select_buttons.each(function () {
            if (!that.__validateSelectButtons($(this))) {
                is_valid = false;
            }
        });

        that.$inputs_select.each(function () {
            if (!that.__validateSelectValue($(this))) {
                is_valid = false;
            }
        });

        that.$inputs_full_name.each(function () {
            if (!that.__validateField($(this))) {
                is_valid = false;
            }
        });

        return is_valid;
    };

    MyDocumentsEdit.prototype.__validateSelectButtons = function ($button) {
        var that = this,
            $inputs = $button.find('.js-select-button-input'),
            error_text = $button.data('error-text'),
            is_valid = false;

        $inputs.each(function () {
            if ($(this).prop('checked')) {
                is_valid = true;
            }
        });

        if (!is_valid) {
            $button
                .addClass('error')
                .find('.js-error-content')
                    .text(error_text)
                    .attr("title", error_text);
        }

        return is_valid;
    };

    MyDocumentsEdit.prototype.__validateSelectValue = function ($select) {
        var that = this,
            $input = $select.find('.js-input'),
            value = $input.val(),
            error_empty = $input.data('error-empty'),
            is_valid = true;

        if (!value) {
            that.__setSelectError($select, error_empty);
            is_valid = false;
        }

        return is_valid;
    };

    MyDocumentsEdit.prototype.__validateDateValue = function ($input) {
        var date = $input.val(),
            date_trim = date.replace(/[^0-9]/g, ''),
            error_text = $input.data('error-text'),
            is_valid = true;

        if ($input.prop('disabled')) {
            return true;
        }

        if (!date || date_trim.length < 8) {
            UIInput.prototype.setError($input, error_text, true);
            return false;
        }

        return is_valid;
    };

    MyDocumentsEdit.prototype.__setSelectError = function ($select, error_text) {
        var that = this,
            $select_input_error = $select.find('.error');

        $select.addClass(that.class.error);
        $select_input_error.text(error_text).attr("title", error_text);
    };

    // Submit

    MyDocumentsEdit.prototype.__initSubmit = function () {
        var that = this;

        that.$form.on('submit', function (e) {
            e.preventDefault();
            that.__saveDocument();
        });
    }

    MyDocumentsEdit.prototype.__saveDocument = function (force = false) {
        var that = this;

        if (that.is_locked || !that.__validateAllFields()) {
            return;
        }

        that.is_locked = true;
        $.sa.buttonLoading(that.$submit_button, true);

        var href = $.sa.build_url(that.save_doc_url),
            data = that.$form.serializeArray();

        if (force) {
            data.push({
                name: 'action',
                value: 'force'
            });
        }

        data.push({
            name: 'id',
            value: that.document_id
        });

        $.post(href, data)
            .done(function (response) {
                if (response.status === 'ok') {
                    that.__handleSuccess(that.operation.save)
                } else if (response.status === 'fail') {
                    that.__handleSaveError(response);
                }
            })
            .fail(function () {
                $.sa.handleErrors();
            }).always(function () {
                that.is_locked = false;
                $.sa.buttonLoading(that.$submit_button, false);
            });
    };

    MyDocumentsEdit.prototype.__handleSaveError = function (result) {
        var that = this,
            errors = result.errors || [],
            $modal_exist_wrapper = $(that.modals['doc_exists']).clone();

        $.each(errors, function (i, error) {
            if (error.code === that.duplicate_code) {
                $.uiModal({
                    mobile_fullscreen: false,
                    $wrapper: $modal_exist_wrapper,
                    onButtonConfirmClick: function () {
                        that.__saveDocument(true);
                    },
                });
            } else {
                $.sa.handleErrors(error);
            }
        });
    };

    // Delete

    MyDocumentsEdit.prototype.__initDelete = function () {
        var that = this;

        that.$delete_button.on('click', function (e) {
            e.preventDefault();

            $.sa.confirm.show({
                title: that.locales['confirm']['delete']['title'],
                content: that.locales['confirm']['delete']['content'],
                button: that.locales['confirm']['delete']['button'],
                onConfirm: function () {
                    that.__deleteDocument();
                }
            });
        });
    };

    MyDocumentsEdit.prototype.__deleteDocument = function () {
        var that = this;
        if (that.is_locked) {
            return false;
        }
        that.is_locked = true;
        $.sa.buttonLoading(that.$submit_button, true);

        var href = $.sa.build_url(that.delete_doc_url),
            data = {
                id: that.document_id
            };
        $.post(href, data)
            .done(function (res) {
                if (res.status === 'ok') {
                    that.__handleSuccess(that.operation.delete)
                } else if (res.status === 'fail') {
                    $.sa.handleErrors(res.errors || []);
                }
            })
            .fail(function () {
                $.sa.handleErrors();
            })
            .always(function () {
                that.is_locked = false;
                $.sa.buttonLoading(that.$submit_button, false);
            });
    };

    //

    MyDocumentsEdit.prototype.__handleSuccess = function (operation) {
        var that = this;

        switch (operation) {
            case that.operation.save:
                $.sa.handleSuccess(that.locales['success']['save']);
                break;
            case that.operation.delete:
                $.sa.handleSuccess(that.locales['success']['delete']);
                break;
        }

        $.sa.content_router.reload();
    };

    return MyDocumentsEdit;
})($);